import Dropzone from 'react-dropzone';
import { Link } from 'gatsby';

import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import ButtonLink from '../components/ui/ButtonLink';

import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

//import ShareButtons from '../components/ShareButtons';
import MoreGoodies from '../components/more-goodies/MoreGoodies';
import BackToTop from '../components/BackToTop';

import { colors } from '../styles/colors';

const PageTemplate = css`
.site-main {
background #fff;
padding-bottom: 4vw;
}

.post-content {
max-width: 1000px;
margin: -2.5rem auto 0;
}
.post-full-content {
  background: transparent;
}
p {
  font-size: 2rem !important;

}
h2 {
  margin-top: 0;
  font-size: 3rem;

  small {
    font-size: 1.5rem;
    font-weight: normal;
  }
}
h2::before {
all: unset !important;
}
h3 {
text-decoration: none !important;
padding-top: 5rem;
text-align: center;
}
`;

const FactsBox = styled.div`
  margin-top: 1.5rem;
  background: #EFFAF2;
  padding: 1.3rem 1.3rem 0.45rem;

  @media (max-width: 750px) {
    padding: 0.1rem 0.1rem 0.1rem;
  }

  li:first-letter {
    color: #ACE3BA;
  }

  h3 {
    padding-top: 0;
  }
`;

const DropZoneDiv = styled.div`
  cursor: pointer;
  border: 2px dashed  ${colors.beta};
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 35px,
    ${colors.beta} 0,
    ${colors.beta} 70px
  );
  max-width: 600px;
  padding: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  p {
    margin-bottom: 0;
    font-weight: bold;
  }
`;

const Logo = styled.div`
  width: 75px;
  height: 75px;
  border-radius: 50%;
  margin: 0 auto 2rem;
  background: linear-gradient(90deg, black 50%, white 50%);
  box-shadow: rgba(39, 44, 49, 0.08) 0px 0px 28px, rgba(39, 44, 49, 0.06) 1px 3px 8px;

  :hover {
    animation: logo-anim 2.5s linear infinite;
  }

  @keyframes logo-anim {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const WrapThumbnails = styled.div`
  display: flex;
  margin: 3rem 0 2rem;
  padding: 0 0 3.2rem;
  overflow-x: scroll;
  scrollbar-color: #D7F2DE #f2eaf8;
  scrollbar-width: auto;
  position: relative;

  -webkit-mask-image: linear-gradient(
    to left,
    transparent 0%,
    black 10%,
    black 90%,
    transparent 100%
  );
  mask-image: linear-gradient(to left, transparent 0%, black 10%, black 90%, transparent 100%);

  img {
    object-fit: cover;
    width: 100px;
    height: 100px;
    min-width: 100px;
    max-width: 100px;
    border-radius: 50%;
    cursor: pointer;
    margin: 0 0.35rem;
  }
  img.active {
    border: 2px dashed;
  }
`;

interface ResultImgProps {
  activeFilter: number;
}

const ResultImg = styled.img<ResultImgProps>`
  max-height: 800px;
  object-fit: cover;

  filter: url(#filter-${props => props.activeFilter});

  :active {
    filter: none;
  }
`;

const ThumbImg1 = styled.img`
  filter: url(#filter-1);
`;
const ThumbImg2 = styled.img`
  filter: url(#filter-2);
`;
const ThumbImg3 = styled.img`
  filter: url(#filter-3);
`;

const ThumbImg4 = styled.img`
  filter: url(#filter-4);
`;
const ThumbImg5 = styled.img`
  filter: url(#filter-5);
`;
const ThumbImg6 = styled.img`
  filter: url(#filter-6);
`;
const ThumbImg7 = styled.img`
  filter: url(#filter-7);
`;
const ThumbImg8 = styled.img`
  filter: url(#filter-8);
`;
const ThumbImg9 = styled.img`
  filter: url(#filter-9);
`;
const ThumbImg10 = styled.img`
  filter: url(#filter-10);
`;
const ThumbImg11 = styled.img`
  filter: url(#filter-11);
`;
const ThumbImg12 = styled.img`
  filter: url(#filter-12);
`;
const ThumbImg13 = styled.img`
  filter: url(#filter-13);
`;
const ThumbImg14 = styled.img`
  filter: url(#filter-14);
`;
const ThumbImg15 = styled.img`
  filter: url(#filter-15);
`;
const ThumbImg16 = styled.img`
  filter: url(#filter-16);
`;

interface BlackAndWhiteConverterState {
  hasCustomImage: boolean;
  photoData: any;
  active: number;
  downloadUrl: string;
}

class BlackAndWhiteConverter extends React.Component<undefined, BlackAndWhiteConverterState> {
  state = {
    hasCustomImage: false,
    photoData: undefined,
    active: 1,
    downloadUrl: '',
  };

  exampleUrl = '/guide/images/black-and-white-converter/example/black-and-white-example-2.jpg';
  photoRef;
  canvasRef;

  descriptions = [
    'low contrast',
    'super low contrast',
    'faded whites',
    'faded blacks',
    'red filter',
    'green filter',
    'blue filter',
    'low contrast red filter',
    'low contrast green filter',
    'low contrast blue filter',
    'infrared',
    'darker mid-tones',
    'high contrast',
    'super high contrast',
    'extreme high contrast',
    'vintage',
  ];

  constructor(props) {
    super(props);
    this.photoRef = React.createRef();
    this.canvasRef = React.createRef();
  }

  setActive = (filterNb: number) => {
    this.setState({ active: filterNb });

    setTimeout(() => {
      const downloadUrl = this.downloadPhoto();
      this.setState({ downloadUrl });
    }, 0);
  };

  onDrop = file => {
    const reader = new FileReader();

    // reader.onabort = () => console.log('file reading was aborted');
    // reader.onerror = () => console.log('file reading has failed');
    reader.onload = () => {
      this.setState({ photoData: reader.result });

      setTimeout(() => {
        const downloadUrl = this.downloadPhoto();
        this.setState({ downloadUrl });
      }, 0);
    };

    reader.readAsDataURL(file[0]);
  };

  downloadPhoto = () => {
    const canvas = this.canvasRef.current;
    const photo = this.photoRef.current;
    const { naturalWidth, naturalHeight } = photo;

    canvas.width = naturalWidth;
    canvas.height = naturalHeight;
    photo.style.maxWidth = 'none';
    photo.style.maxHeight = 'none';
    photo.style.width = naturalWidth;
    photo.style.height = naturalHeight;

    const ctx = canvas.getContext('2d');
    ctx.filter = `url(#filter-${this.state.active})`;
    ctx.drawImage(photo, 0, 0, photo.width, photo.height);

    photo.style.maxWidth = '100%';
    photo.style.maxHeight = '800px';

    return canvas.toDataURL('image/jpeg');
  };

  render() {
    return (
      <IndexLayout>
        <Helmet>
          <title>Online Black & White Photo Converter with Photoshop Actions | Giggster</title>
          <meta
            name="description"
            content="A free online tool and set of Photoshop actions to convert your photos to black & white. You'll be able to preview 16 different black and white variations."
          />

          <meta property="og:site_name" content="Giggster" />
          <meta property="og:type" content="article" />
          <meta
            property="og:title"
            content="Online Black & White Photo Converter with Photoshop Actions"
          />
          <meta
            property="og:description"
            content="A free online tool and set of Photoshop actions to convert your photos to black & white. You'll be able to preview 16 different black and white variations."
          />
          <meta property="og:url" content="https://giggster.com/guide/black-and-white-converter/" />
          <meta
            property="og:image"
            content="https://giggster.com/guide/covers/black-and-white-converter.jpg"
          />
          <meta property="article:publisher" content="https://www.facebook.com/giggsterHQ" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Online Black & White Photo Converter with Photoshop Actions"
          />
          <meta
            name="twitter:description"
            content="A free online tool and set of Photoshop actions to convert your photos to black & white. You'll be able to preview 16 different black and white variations."
          />
          <meta name="twitter:url" content="https://giggster.com/guide/black-and-white-converter/" />
          <meta
            name="twitter:image"
            content="https://giggster.com/guide/covers/black-and-white-converter.jpg"
          />
          <meta name="twitter:site" content="@Giggster" />
          <meta name="twitter:creator" content="@Giggster" />
        </Helmet>
        <Wrapper css={PageTemplate}>
          <header css={[outer, SiteHeader]}>
            <div css={inner}>
              <SiteNav />
            </div>
          </header>
          <main id="site-main" className="site-main" css={[SiteMain, outer]}>
            <article className="post page" css={[PostFull, NoImage]}>
              <PostFullHeader>
                <PostFullTitle>
                  <Logo />
                  Black & White Photo Converter with Free Photoshop Actions
                </PostFullTitle>
                <p className="t2">
                  Preview different black and white effects on your images and apply them directly
                  or use the free Photoshop actions to apply them as part of your retouching
                  workflow. <a href="#how-it-works">Learn how it works here</a>.
                </p>
                
                {/*<ShareButtons
                  title={'Online Black and White Photo Converter'}
                  slug={'/black-and-white-converter/'}
                  imgSrc={'covers/black-and-white-converter.jpg'}
                />*/}
              </PostFullHeader>

              <PostFullContent className="post-full-content">
                <div className="post-content text-center">
                  <h2 className="text-center">Upload Your Image</h2>

                  <Dropzone multiple={false} accept="image/jpeg, image/png" onDrop={this.onDrop}>
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <DropZoneDiv {...getRootProps()}>
                          <input {...getInputProps()} />
                          <p>Drag a photo here, or click to select one</p>
                        </DropZoneDiv>
                      </section>
                    )}
                  </Dropzone>

                  <hr />

                  <WrapThumbnails>
                    <ThumbImg1
                      className={this.state.active === 1 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(1)}
                    />
                    <ThumbImg2
                      className={this.state.active === 2 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(2)}
                    />
                    <ThumbImg3
                      className={this.state.active === 3 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(3)}
                    />
                    <ThumbImg4
                      className={this.state.active === 4 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(4)}
                    />
                    <ThumbImg5
                      className={this.state.active === 5 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(5)}
                    />
                    <ThumbImg6
                      className={this.state.active === 6 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(6)}
                    />
                    <ThumbImg7
                      className={this.state.active === 7 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(7)}
                    />
                    <ThumbImg8
                      className={this.state.active === 8 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(8)}
                    />
                    <ThumbImg9
                      className={this.state.active === 9 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(9)}
                    />

                    <ThumbImg10
                      className={this.state.active === 10 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(10)}
                    />
                    <ThumbImg11
                      className={this.state.active === 11 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(11)}
                    />

                    <ThumbImg12
                      className={this.state.active === 12 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(12)}
                    />
                    <ThumbImg13
                      className={this.state.active === 13 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(13)}
                    />
                    <ThumbImg14
                      className={this.state.active === 14 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(14)}
                    />

                    <ThumbImg15
                      className={this.state.active === 15 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(15)}
                    />

                    <ThumbImg16
                      className={this.state.active === 16 ? 'active' : ''}
                      src={this.state.photoData ? this.state.photoData : this.exampleUrl}
                      // tslint:disable-next-line:react-this-binding-issue
                      onClick={() => this.setActive(16)}
                    />
                  </WrapThumbnails>

                  {this.state.photoData ? (
                    <ResultImg
                      activeFilter={this.state.active}
                      src={this.state.photoData}
                      // tslint:disable-next-line
                      onTouchStart={() => {}}
                      ref={this.photoRef}
                    />
                  ) : (
                    <ResultImg
                      activeFilter={this.state.active}
                      src={this.exampleUrl}
                      ref={this.photoRef}
                      // tslint:disable-next-line
                      onTouchStart={() => {}}
                    />
                  )}
                  <h2 className="text-center">
                    Black and White #{this.state.active} &#8212;{' '}
                    {this.descriptions[this.state.active - 1]}
                    <br />
                    <small>(tap/click on image to view original)</small>
                  </h2>

                  <p>
                    <ButtonLink
                      href="https://purple11.s3.amazonaws.com/actions/purple11-black-and-white.zip"
                      download
                    >
                      Download Photoshop Actions
                    </ButtonLink>{' '}
                    {this.state.downloadUrl ? (
                      <>
                        <ButtonLink
                          href={this.state.downloadUrl}
                          download={`black-and-white-${this.state.active}.jpg`}
                        >
                          Download Photo
                        </ButtonLink>
                        <br />
                        <small>
                          Note that downloading the photo directly only works in Chrome or Firefox
                          for now
                        </small>
                      </>
                    ) : (
                      ''
                    )}
                  </p>

                  <hr />

                  <FactsBox>
                    <h3 name="how-it-works">How it works</h3>
                    <ul>
                      <li>
                        &#9673; Converting a photo to black and white can be about much more than
                        simply desaturating/removing the colors from the image. It can also be about
                        tweaking the overall contrast or applying different color filters to achieve
                        a final black and white that looks just right for the image. If you're
                        interested in learning more, I recommend{' '}
                        <Link to="/retouching/gradient-map-high-contrast-b-w/">
                          this post about using a gradient map
                        </Link>{' '}
                        for black and white or{' '}
                        <Link to="/retouching/black-white-channel-mixer/">
                          this post about using a channel mixer adjustment
                        </Link>{' '}
                        for black and white.
                      </li>

                      <li>
                        &#9673; Here you can upload a Jpeg image and quickly preview different black
                        and white variations.
                      </li>

                      <li>
                        &#9673; To get started, download the{' '}
                        <a
                          href="https://purple11.s3.amazonaws.com/actions/purple11-black-and-white.zip"
                          download
                        >
                          free Photoshop actions
                        </a>
                        . Unzip the file and double click on the action file to install it, or go in
                        Photoshop into the action panel's menu and choose <em>Load Actions...</em>
                      </li>

                      <li>
                        &#9673; Once you like a particular black and white variation for your photo,
                        you can either download the photo directly{' '}
                        <strong>(only available in Chrome and Firefox for the moment)</strong>, or
                        play the action with the corresponding number (e.g.: Black and White #6) in
                        Photoshop.
                      </li>
                      <li>
                        &#9673; Once you've applied the action, feel free to tweak the settings of
                        the applied adjustments so that it fits the image just right. That means
                        that you can also use these adjustments as starting points if you'd like.
                      </li>
                    </ul>
                  </FactsBox>
                  <hr />
               
                </div>
              </PostFullContent>
            </article>
            <MoreGoodies slug="black-and-white-converter" />
          </main>
          <BackToTop />
          <Footer />
        </Wrapper>

        <canvas ref={this.canvasRef} style={{ display: 'none' }} />
        <svg version="1.1" width="0" height="0">
          {/* Faded both ways, normal low contrast, Color stops: #191919, #EFEFEF */}
          <filter id="filter-1" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.1 0.94" />
              <feFuncG type="table" tableValues="0.1 0.94" />
              <feFuncB type="table" tableValues="0.1 0.94" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Faded both ways, super low contrast, Color stops: #333333, #7F7F7F */}
          <filter id="filter-2" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />

            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.2 0.5" />
              <feFuncG type="table" tableValues="0.2 0.5" />
              <feFuncB type="table" tableValues="0.2 0.5" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Faded whites, Color stops: #000000, #C7C7C7 */}
          <filter id="filter-3" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 0.78" />
              <feFuncG type="table" tableValues="0 0.78" />
              <feFuncB type="table" tableValues="0 0.78" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Faded blacks, Color stops: #424242, #FFFFFF */}
          <filter id="filter-4" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.26 1" />
              <feFuncG type="table" tableValues="0.26 1" />
              <feFuncB type="table" tableValues="0.26 1" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Red filter, Color stops: #000000, #FFFFFF */}
          <filter id="filter-5" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
            1 0 0 0 0
            1 0 0 0 0
            0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 1" />
              <feFuncG type="table" tableValues="0 1" />
              <feFuncB type="table" tableValues="0 1" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Green filter, Color stops: #000000, #FFFFFF */}
          <filter id="filter-6" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0 1 0 0 0
            0 1 0 0 0
            0 1 0 0 0
            0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 1" />
              <feFuncG type="table" tableValues="0 1" />
              <feFuncB type="table" tableValues="0 1" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Blue filter, Color stops: #000000, #FFFFFF */}
          <filter id="filter-7" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0 0 1 0 0
            0 0 1 0 0
            0 0 1 0 0
            0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0 1" />
              <feFuncG type="table" tableValues="0 1" />
              <feFuncB type="table" tableValues="0 1" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Low contrast red filter, Color stops: #191919, #EFEFEF */}
          <filter id="filter-8" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
            1 0 0 0 0
            1 0 0 0 0
            0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.1 0.94" />
              <feFuncG type="table" tableValues="0.1 0.94" />
              <feFuncB type="table" tableValues="0.1 0.94" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Low contrast green filter, Color stops: #191919, #EFEFEF */}
          <filter id="filter-9" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0 1 0 0 0
            0 1 0 0 0
            0 1 0 0 0
            0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.1 0.94" />
              <feFuncG type="table" tableValues="0.1 0.94" />
              <feFuncB type="table" tableValues="0.1 0.94" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Low contrast blue filter, Color stops: #191919, #EFEFEF */}
          <filter id="filter-10" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0 0 1 0 0
            0 0 1 0 0
            0 0 1 0 0
            0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="0.1 0.94" />
              <feFuncG type="table" tableValues="0.1 0.94" />
              <feFuncB type="table" tableValues="0.1 0.94" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* infrared: #ffffff, #000000 */}
          <filter id="filter-11" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer in="colormatrix" result="componentTransfer">
              <feFuncR type="table" tableValues="1 0" />
              <feFuncG type="table" tableValues="1 0" />
              <feFuncB type="table" tableValues="1 0" />
              <feFuncA type="table" tableValues="0 1" />
            </feComponentTransfer>
          </filter>

          {/* Darker mid-tones gradient map: "black, gray 75%, white" */}
          <filter id="filter-12" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              result="gray"
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR
                type="table"
                tableValues="0 0.16732026143790849 0.33464052287581697 0.5019607843137255 1"
              />
              <feFuncG
                type="table"
                tableValues="0 0.16732026143790849 0.33464052287581697 0.5019607843137255 1"
              />
              <feFuncB
                type="table"
                tableValues="0 0.16732026143790849 0.33464052287581697 0.5019607843137255 1"
              />
              <feFuncA type="table" tableValues="0 1 1 1 1" />
            </feComponentTransfer>
          </filter>

          {/* high contrast gradient map: black, black 10%, white 90%, white" */}
          <filter id="filter-13" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 0 0.125 0.25 0.375 0.5 0.625 0.75 0.875 1 1" />
              <feFuncG type="table" tableValues="0 0 0.125 0.25 0.375 0.5 0.625 0.75 0.875 1 1" />
              <feFuncB type="table" tableValues="0 0 0.125 0.25 0.375 0.5 0.625 0.75 0.875 1 1" />
              <feFuncA type="table" tableValues="0 1 1 1 1 1 1 1 1 1 1" />
            </feComponentTransfer>
          </filter>

          {/* super high contrast gradient map: black, black 15%, white 85%, white" */}
          <filter id="filter-14" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 0 0.2 0.4 0.6 0.8 1 1" />
              <feFuncG type="table" tableValues="0 0 0.2 0.4 0.6 0.8 1 1" />
              <feFuncB type="table" tableValues="0 0 0.2 0.4 0.6 0.8 1 1" />
              <feFuncA type="table" tableValues="0 1 1 1 1 1 1 1" />
            </feComponentTransfer>
          </filter>

          {/* extreme high contrast gradient map: black, black 20%, white 80%, white" */}
          <filter id="filter-15" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 0 0.3333333333333333 0.6666666666666666 1 1" />
              <feFuncG type="table" tableValues="0 0 0.3333333333333333 0.6666666666666666 1 1" />
              <feFuncB type="table" tableValues="0 0 0.3333333333333333 0.6666666666666666 1 1" />
              <feFuncA type="table" tableValues="0 1 1 1 1 1" />
            </feComponentTransfer>
          </filter>

          {/* vintage gradient map: "#222222, #222222 15%, white 85%, white" */}
          <filter id="filter-16" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"
              in="SourceGraphic"
              result="colormatrix"
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR
                type="table"
                tableValues="0.13333333333333333 0.13333333333333333 0.3066666666666667 0.48000000000000004 0.6533333333333334 0.8266666666666667 1 1"
              />
              <feFuncG
                type="table"
                tableValues="0.13333333333333333 0.13333333333333333 0.3066666666666667 0.48000000000000004 0.6533333333333334 0.8266666666666667 1 1"
              />
              <feFuncB
                type="table"
                tableValues="0.13333333333333333 0.13333333333333333 0.3066666666666667 0.48000000000000004 0.6533333333333334 0.8266666666666667 1 1"
              />
              <feFuncA type="table" tableValues="0 1 1 1 1 1 1 1" />
            </feComponentTransfer>
          </filter>
        </svg>
      </IndexLayout>
    );
  }
}

export default BlackAndWhiteConverter;
